import { Container } from 'reactstrap';
import { Image, H5, } from '../../../AbstractElements';
import { CommingSoontext, SOON, } from '../../../Constant';
import CountdownData from './CountdownData';

const ComingSimple = () => {
  return (
    <div className='page-wrapper compact-wrapper' id='pageWrapper'>
      <Container fluid={true} className='p-0'>
        <div className='comingsoon'>
          <div className='comingsoon-inner text-center'>
            <div className='logo-wrraper'>
              <Image className='img-fluid mx-auto' src={require('../../../assets/images/logo/footer-logo.png')} />
            </div>
            <H5>
              {CommingSoontext}
              <br />
              {SOON}
            </H5>

            <div className='countdown' id='clockdiv'>
              <CountdownData />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default ComingSimple;
